import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
  },
  textField: {
    marginTop: 13,
  },
}));
